import type { FaireProductEntity } from "../../entity_types/product";

export const p_psbcpv27wq: FaireProductEntity = {
  token: "p_psbcpv27wq",
  type: "product",
  name: "Shampoo Bar | Sweet Orange + Grapefruit | Zero Waste",
  brandToken: "b_7epwzqn7do",
  brandName: "Zero Waste MVMT",
  imageUrl:
    "https://cdn.faire.com/fastly/89206682239bac09bde0f1221cbff70da84d0c82114abbddfb84c4ab45671c60.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3cec29d60c6f931f51a4c86c41624898788455c90f2b045dfc8bb72a556bac3d.png",
    "https://cdn.faire.com/fastly/ead97425ad4ba743fcefdd3e8be9430fbdc0bec72d15dd4310ec6bc9203c37b0.jpeg",
    "https://cdn.faire.com/fastly/163282d5e3c4234263814fb8d5cdb98b04637020f5e3f7054d858549d1332caf.jpeg",
    "https://cdn.faire.com/fastly/c2b505cc3f2dcb7a199163be9aecee8796e8cbcfd60bb35bf4426fee0948530c.jpeg",
    "https://cdn.faire.com/fastly/dad31dbd944d121082f8779ac9266c435df309e14bebcba52ff6b8190d841f7f.jpeg",
    "https://cdn.faire.com/fastly/ed3d89fd6b71a7ea729aa52364d578b24a3adfbba5544503999ea8ef083f4715.gif",
    "https://cdn.faire.com/fastly/347e26043e148da248fe6ff36764d0ec1bc9946e4753620b5e8fec7fa764fcb0.jpeg",
    "https://cdn.faire.com/fastly/95eaecaee0ec8858401b7807b1d359c596859dcbcfcbc4b973e55cd0ad72952b.jpeg",
    "https://cdn.faire.com/fastly/bdd1d6fabef171dbd6c6878b39bf5ac6a6e71b6545932409feaf3dfe28dd9f17.jpeg",
  ],
  priceDollars: 9.75,
  description:
    "Our Sweet Orange + Grapefruit Shampoo Bar offers a burst of citrus freshness for a revitalizing, zero-waste hair care routine. Infused with the bright, zesty aromas of sweet orange, pink grapefruit, and lemon oils, this shampoo bar fills your shower with an uplifting, sun-kissed fragrance.\n\nFormulated with coconut oil and cocoa butter, it gently cleanses while adding hydration, shine, and manageability to your hair. Designed for eco-conscious individuals, this bar transforms your wash into an energizing experience, caring for both your hair and the planet with each use.\n\nSize: Approx. 2.5” x .75” and 2 oz.\n\n🌱Just 1 bar can replace up to 3-250ml bottles of shampoo and last for 50-75+ washes.\n\nABOUT ZERO WASTE MVMT\n\nZero Waste MVMT is an eco-conscious brand on a mission to help you live more sustainably with plastic-free reusables and natural, earth-friendly products 🌱  We always ship plastic-free and all deliveries are carbon neutral 🌎",
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:31.547Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
